import { createMediaSpec, defaultAttrs } from './media';
export var mediaInline = createMediaSpec(defaultAttrs, true);